import { Button, Card, InputAdornment, Stack, TextField } from "@mui/material";
import Iconify from "../../../../../components/iconify";
import { ChangeEvent } from "react";
import useUserUpdateSystem from "./useUseUpdateSystem";
import TableComponent from "../../../../../components/table";
import { columnsTableUpdateSystem } from "../../../../../constants/user";
import UserUpdateSystemTableRow from "./components/table.row";
import { ISystemBranch } from "../../../../../types/user";

const UpdateSystemsUserView = () => {

    const { loading, nameSystem, setNameSystem, systems, table, handleCheckboxChange, selectedItems, buttonDisabled, updateSystems, systemBranches } = useUserUpdateSystem();

    return (
        <>
            <Stack
                spacing={3}
                sx={{ mb: { xs: 3, md: 5 } }}
                justifyContent={'space-between'}
                alignItems={{ xs: 'flex-end', md: 'center' }}
                direction={{ xs: 'column', md: 'row' }}
            >
                <TextField
                    placeholder="Pesquisar..."
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon={"eva:search-fill"} sx={{ ml: 1, color: 'text.disabled' }} />
                            </InputAdornment>
                        )
                    }}
                    sx={{ width: { xs: 1, md: 260 } }}
                    value={nameSystem}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => setNameSystem(event.target.value)}
                />
                <Button 
                    variant="contained"
                    onClick={updateSystems}
                    disabled={buttonDisabled.value}
                >
                    Salvar
                </Button>
            </Stack>
            <Card>
                <TableComponent
                    table={table}
                    headLabel={columnsTableUpdateSystem}
                    loading={loading.value}
                    totalCount={systems?.length ?? 0}
                    removePaginate
                >
                    <>
                        {
                            systemBranches?.map((systemBranch: ISystemBranch) => {
                                return (
                                    <UserUpdateSystemTableRow
                                        key={systemBranch.branchId + '-' + systemBranch.systemId}
                                        row={systemBranch}
                                        handleCheckboxChange={handleCheckboxChange}
                                        selectedItens={selectedItems}
                                    />
                                )
                            })                       
                        }
                    </>
                </TableComponent>
            </Card>
        </>
    )

}

export default UpdateSystemsUserView;